package game.scenes;

import cerastes.misc.Random;
import h2d.Interactive;
import cerastes.LocalizationManager;
import haxe.display.Position;
import cerastes.flow.Flow.FlowRunner;
import cerastes.ui.Reference;
import cerastes.Utils;
import hxd.Key;
import cerastes.c2d.DebugDraw;


@:keep
class EndScene extends LDScene
{

	@:obj var intClick: Interactive;


	override function enter()
	{
		super.enter();
		GameState.reset();

		ui = hxd.Res.ui.end.toObject(s2d);

		var root = s2d;
		cerastes.macros.UIPopulator.populateObjects();

		createComponents();

		trace("PRNG stability test:");
		var r = new Random( 1 );
		trace(r.getUpTo(10));
		var r = new Random( 10 );
		trace(r.getUpTo(10));
		var r = new Random( 11 );
		trace(r.getUpTo(10));

	}


	override function tick( delta:Float )
	{


		super.tick(delta);
		
	}

	override function exit()
	{
		super.exit();
	}


	override function preload()
	{
		super.preload();
	}
}
